import { seriesLiqui } from "./series.js"
import {
	chartAlterLabel,
	chartJahresLabel,
	chartMonatsLabel,
	realZuChartX,
	updateDataGrouping,
	zoomIn,
} from "./zeitachse.js"
import { buildTooltipFormatter } from "./tooltip.js"
import {
	buildBewertungsPlotline,
	buildZinsbindungsPlotBands,
	initialeZinsbindungsphasen,
	updateChartDekorationen,
} from "./dekorationen.js"

export function buildConfig(chartKredit) {
	const data = chartKredit.data

	return {
		chart: {
			events: {
				selection: function (event) {
					return zoomIn(chartKredit, event)
				},
				render: function () {
					chartKredit.onRender?.()
				},
			},
		},

		yAxis: [
			{},
			{
				opposite: true,
			},
		],

		xAxis: {
			ordinal: false,
			min: realZuChartX(data.startdatum, data),
			max: realZuChartX(data.enddatum, data),
			labelFormat: "alter",
			plotLines: [
				buildBewertungsPlotline({
					bewertungsdatum: realZuChartX(data.bewertungsdatum, data),
					labelDatum: data.bewertungsdatum,
				}),
			].filter(Boolean),
			plotBands: buildZinsbindungsPlotBands(initialeZinsbindungsphasen(data)),
			labels: {
				formatter: function () {
					const groupingAktiv = !!this.axis.chart.options.plotOptions.series.dataGrouping.enabled
					const labelFormat = this.axis.options.labelFormat || "alter"

					if (labelFormat === "alter") return chartAlterLabel(chartKredit.data, this.value, groupingAktiv)
					if (!groupingAktiv) return chartMonatsLabel(chartKredit.data, this.value)

					return chartJahresLabel(chartKredit.data, this.value)
				},
			},
			events: {
				afterSetExtremes: function (event) {
					updateDataGrouping(event.target.chart, event.min, event.max)
					updateChartDekorationen(chartKredit)
				},
			},
		},

		tooltip: {
			shared: true,
			split: true,
			useHTML: true,
			borderRadius: 8,
			formatter: buildTooltipFormatter(chartKredit),
		},

		legend: {
			enabled: true,
			events: {
				itemClick: function (event) {
					const item = event?.legendItem
					const seriesId = item?.options?.id
					if (!seriesId) return true

					const willBeVisible = !item.visible
					chartKredit.onLegendToggle?.(seriesId, willBeVisible)
					return true
				},
			},
		},

		plotOptions: {
			series: {},
		},

		series: seriesLiqui(data),
	}
}
